<template>
    <span>
        <v-dialog
            v-model="closeShiftModalShow"
            persistent
            max-width="600"
        >
            <v-card>
                <v-card-title class="display-3 text--primary">
                    <v-spacer></v-spacer>
                    <h5>Закрыть смену</h5>
                    <v-spacer></v-spacer>
                </v-card-title>
                <template v-if="shiftInfo.unclosed_orders">
                    <v-card-subtitle class="display-6 text--primary">
                        Неоплаченные заказы
                    </v-card-subtitle>
                    <v-card-text>
                        В смене есть неоплаченные заказ-наряды. При закрытии
                        смены все неоплаченные заказ-наряды будут удалены!
                    </v-card-text>
                </template>
                <template v-if="motivation.status == '1'">
                    <v-card-subtitle class="display-6 text--primary">
                        Мотивити
                    </v-card-subtitle>
                    <v-card-text v-html="motivationCheck()"> </v-card-text>
                </template>
                <v-card-actions>
                    <v-btn
                        color="warning"
                        text
                        @click="cancelCloseShift"
                    >
                        отмена
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="success"
                        text
                        @click="getQqBeforClose"
                        data-test-id="successCloseShiftButton"
                    >
                        Подтвердить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <questionnaire @close="closeAllPopup" :qtype="'close'" :showQq="showQq" @submit="submitCloseShift" />
    </span>
</template>

<script>
export default {
  name: 'closeShift',
  props: ['value'],
  components: {
    questionnaire: () => import('./questionnaire')
  },
  data() {
    return {
      showQq: false,
    }
  },
  computed: {
    closeShiftModalShow: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    shiftData () {
      return this.$store.getters['shift/shiftData']
    },
    shiftInfo () {
      return this.$store.getters['shift/shiftInfo']
    },
    motivation() {
      return this.shiftInfo.motivation ? this.shiftInfo.motivation : {};
    },
  },
  methods: {
    cancelCloseShift () {
      this.closeShiftModalShow = false
      this.$emit('cancelCloseShift')
    },
    closeAllPopup() {
      this.cancelCloseShift()
        this.showQq = false
    },
    getQqBeforClose () {
      this.showQq = true
      this.closeShiftModalShow = false
    },
    submitCloseShift(qQsendFn) {
      console.log('qQanswer', qQsendFn)
      this.showQq = false
      this.$emit('submitCloseShift')
      // if (qQsendFn !== null) qQsendFn()
      // this.$store.dispatch("shift/closeShift", this.shiftData);
      // this.$store.dispatch("shift/fetchShiftData");
    },
    motivationCheck() {
      //TODO: update shiftInfo
      // check that user is participant at least of one nomination
      if (
          this.motivation.status == "1" &&
          this.motivation.sliced &&
          !this.motivation.less20hours
      ) {
        let winners = this.motivation.winners;
        let results = "Результаты мотивити: <br/>";
        winners.forEach(element => {
          results += `В номинации ${element.title} победил ${element.fullName}. Мастерская ${element.workshop}. Награда составила ${element.reward} руб.<br/>`;
        });
        return results;
      } else if (
          this.motivation.status == "1" &&
          this.motivation.less20hours
      ) {
        return "Вы закрываете смену длительностью менее 20 часов. Данная смена не сможет быть учтена в системе Motivity. Для участия в Motivity необходима смена длительностью более 20 часов.";
      } else if (
          this.motivation.status == "1" &&
          !this.motivation.sliced &&
          !this.motivation.less20hours
      )
        return "Итоговые результаты MOTIVITY будут доступны в 10:00. Зарегистрируйтесь в телеграмм боте, чтобы получать уведомления о результатах каждую смену.";
    },
  }
}
</script>
